/*
  文字組みと表の共通処理 (ADR-0009)。全ページで読み込む (layout/theme.liquid、defer)。

  1. 最後の 1 文字だけが次の行に落ちないようにする
     見出し・本文・表のセルの「最後の 2 文字」を折れない塊にする (= 最後の行は必ず 2 文字以上)。
     値段の「4,760円」「19,800円〜」も 1 つの塊にする (= 行頭に「円」が来ない)。
     CSS の text-wrap: balance / pretty は iOS 18 以前の Safari が対応していない、
     Chrome も <br> のある見出しでは balance しないので、ブラウザに頼らずここで揃える。
     文字は変えず <prodig-nw> で包むだけ (= ページ内検索・コピーはそのまま)。
     span にしないのは、各 section の「.見出し span { display:block }」のような指定に巻き込まれないため。

  2. SP で表をカードにする (table[data-sp-cards])
     見出しの行 (thead、無ければ最初の行の th) の文字を各セルの data-label に写す。
     見た目は assets/prodig-rental-sp.css の table[data-sp-cards]。

  対象外: 見積もりウィジェット・カート (JS が描き直す)、入力欄、読み上げ専用の文字。
*/
(function () {
  'use strict';

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1, SELECT: 1, TITLE: 1, PRE: 1, CODE: 1, BUTTON: 1, svg: 1 };
  var SKIP_SELECTOR = '[contenteditable], prodig-nw, .visually-hidden, .sr-only, [data-no-nw], .prodig-rental-estimate, [id^="prodig-rental-estimate"], .prodig-contact-cart, form';
  // 日本語の文字 (かな・漢字・全角の記号と英数)。英単語は元々途中で折れないので触らない
  var CJK = /[　-ヿ㐀-鿿豈-﫿！-｠]/;
  var PRICE = /\d[\d,]*円[〜～~]?[）)」』、。]?/g; // 閉じ括弧・句読点も同じ塊に (「（475円）」の「）」だけが次の行に落ちない)

  function skip(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      if (SKIP_TAGS[e.tagName]) return true;
    }
    return !!(el.closest && el.closest(SKIP_SELECTOR));
  }

  var displayCache = new Map();
  function boxParent(el) {
    if (!displayCache.has(el)) displayCache.set(el, /flex|grid/.test(getComputedStyle(el).display));
    return displayCache.get(el);
  }

  function wrap(textNode, start, end) {
    var mid = start > 0 ? textNode.splitText(start) : textNode;
    if (end - start < mid.nodeValue.length) mid.splitText(end - start);
    var el = document.createElement('prodig-nw');
    mid.parentNode.insertBefore(el, mid);
    el.appendChild(mid);
  }

  function guard(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.trim().length < 3 || !n.parentElement || skip(n.parentElement)) continue;
      if (boxParent(n.parentElement)) {
        // flex / grid の直下の文字は、そのまま途中を包むと箱が 2 つに分かれて間が空く。
        // 先に文字全体を 1 つの箱 (<prodig-tx>、飾りなし) に入れてから、その中で包む = 箱の数は今までと同じ 1 つ
        var box = document.createElement('prodig-tx');
        n.parentNode.insertBefore(box, n);
        box.appendChild(n);
      }
      nodes.push(n);
    }
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var ranges = [];
      var m;
      PRICE.lastIndex = 0;
      while ((m = PRICE.exec(text))) ranges.push([m.index, m.index + m[0].length]);
      var end = text.replace(/\s+$/, '').length;
      if (CJK.test(text.charAt(end - 1))) {
        // 「10〜50台」のように数字で始まる時は数字ごと (= 「5」と「0台」に割れない)
        var start = end - 2;
        while (start > 0 && /[\d,.]/.test(text.charAt(start)) && /[\d,.]/.test(text.charAt(start - 1))) start--;
        if (start >= 0 && /\S/.test(text.charAt(start)) && (CJK.test(text.charAt(start)) || /\d/.test(text.charAt(start)))) ranges.push([start, end]);
      }
      if (!ranges.length) return;
      // 重なる塊はまとめて、後ろから包む (前の位置がずれないように)
      ranges.sort(function (x, y) { return x[0] - y[0]; });
      var merged = [ranges[0]];
      for (var i = 1; i < ranges.length; i++) {
        var last = merged[merged.length - 1];
        if (ranges[i][0] <= last[1]) last[1] = Math.max(last[1], ranges[i][1]);
        else merged.push(ranges[i]);
      }
      for (var j = merged.length - 1; j >= 0; j--) wrap(node, merged[j][0], merged[j][1]);
    });
  }

  function labelTables() {
    var tables = document.querySelectorAll('table[data-sp-cards]');
    Array.prototype.forEach.call(tables, function (table) {
      var head = table.querySelector('thead tr') || table.querySelector('tr');
      if (!head) return;
      var labels = Array.prototype.map.call(head.children, function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); });
      Array.prototype.forEach.call(table.querySelectorAll('tr'), function (tr) {
        if (tr === head) { tr.setAttribute('data-sp-head', ''); return; }
        Array.prototype.forEach.call(tr.children, function (cell, i) {
          if (labels[i] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', labels[i]);
        });
      });
    });
  }

  function run() {
    labelTables();
    guard(document.body);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
